@if (datePicker.currentMode === 'day') {
  <div class="td-wb-day-picker-header">
    <div class="td-wb-table__cell--left">
      <button type="button"
              tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef()"
              class="td-wb-left td-wb-day-picker__arrow-button"
              (click)="datePicker.move(-1)"
              [disabled]="navPrevDisabled()"
              [attr.aria-label]="'tdWb.dayPicker.PREVIOUS_MONTH' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-left"
                    size="9x14" />
      </button>
    </div>
    <div [attr.colspan]="3 + (datePicker.showWeeks() ? 1 : 0)">
      <strong [id]="datePicker.uniqueId + '-day-title'"
              class="td-wb-vh"
              aria-live="assertive"
              role="heading"
              aria-level="1"
              [innerText]="title()"></strong>
      @if (datePicker.currentMode !== datePicker.maxMode()) {
        <button tdWbDatePickerButton
                #yearButton
                type="button"
                class="td-wb-full-width td-wb-day-picker__month-button"
                (click)="datePicker.toggleMode(0)"
                [disabled]="datePicker.currentMode === datePicker.maxMode()"
                [attr.aria-label]="'tdWb.dayPicker.VIEW_MONTH_CALENDAR' | tdWbTranslate">
          <span class="td-wb-date-picker-header" [innerText]="title()"></span>
        </button>
      }
      @if (datePicker.currentMode === datePicker.maxMode()) {
        <span class="td-wb-date-picker-header"
              [innerText]="title()"></span>
      }
    </div>
    <div class="td-wb-table__cell--right">
      <button type="button"
              tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef()"
              class="td-wb-right td-wb-day-picker__arrow-button"
              (click)="datePicker.move(1)"
              [disabled]="navNextDisabled()"
              [attr.aria-label]="'tdWb.dayPicker.NEXT_MONTH' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-right"
                    size="9x14" />
      </button>
    </div>
  </div>
}
<table [hidden]="datePicker.currentMode !== 'day'"
       class="td-wb-day-picker__table"
       role="grid"
       [attr.aria-labelledby]="datePicker.uniqueId + '-day-title'"
       [attr.aria-activedescendant]="datePicker.activeDateId() || null">
  <thead>
  <tr>
    @if (datePicker.showWeeks()) {
      <th class="td-wb-table__cell--center"></th>
    }
    @for (label of labels(); track label.abbr) {
      <th class="td-wb-table__cell--center">
        <small [attr.aria-label]="label.full">
          <span class="td-wb-date-picker-subheader"
                [innerText]="label.abbr"></span>
        </small>
      </th>
    }
  </tr>
  </thead>
  <tbody>
    @for (row of rows(); track index; let index = $index) {
      <tr>
        @if (datePicker.showWeeks()) {
          <td class="td-wb-table__cell--center">
            <em class="td-wb-italic"
                [innerText]="weekNumbers()?.[index]"></em>
          </td>
        }
        @for (dt of row; track dt.uid) {
          <td class="td-wb-table__cell--center"
              role="gridcell"
              [id]="dt.uid"
              [attr.aria-label]="getAriaLabel(dt.date)"
              [attr.aria-disabled]="!!dt.disabled">
            @if (dt.isVisible) {
              <button type="button"
                      tdWbDatePickerButton
                      class="td-wb-date-picker-cell"
                      [class.td-wb-date-picker-button--active]="dt.selected"
                      (click)="datePicker.select(dt.date)"
                      [disabled]="dt.disabled">
            <span [class.text-muted]="dt.secondary"
                  [class.text-info]="dt.current"
                  [innerText]="dt.label">
            </span>
              </button>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
